import { useContext } from 'react';

import { PortalConfigContext } from 'src/context';

/**
 * True when the workspace signed up from a marketing-site prompt or template. Those
 * users arrived to build a specific app, so onboarding leads with building it and
 * brings in the CRM afterwards, instead of opening on the CRM.
 */
export const useIsAppFirstSignup = (): boolean => {
  const { initialPrompt, appTemplateId } = useContext(PortalConfigContext);
  return Boolean(initialPrompt?.trim() || appTemplateId);
};
